import { lazy } from 'react';

// The one place that decides whether Young Connect exists in this build.
//
// REACT_APP_ENV is baked in at build time (client package.json scripts and the
// pipelines). webpack only leaves a lazy chunk out of the build when the
// condition guarding the import() is a literal comparison on process.env that
// its parser can fold, so the comparison is written out here, next to the
// import, and everything else derives from the result. Hiding it behind an
// imported constant still emits the chunk, so production would ship the code.
// scripts/check-young-connect-bundle.js proves the chunk is absent.
//
// Anything other than staging or development, including an unset value,
// leaves the module off.
export const YoungConnectRoutes =
  process.env.REACT_APP_ENV === 'staging' ||
  process.env.REACT_APP_ENV === 'development'
    ? lazy(() => import('../routes'))
    : null;

export const isYoungConnectEnabled = YoungConnectRoutes !== null;
